import CookieService from "./cookieService";

export const logout = () => {
  CookieService().clearToken();
  sessionStorage.clear();
  localStorage.removeItem("customer");
};
